export default __webpack_public_path__ + "16a504630f91dccafb55ed102bc1fb62.svg";